import { render, staticRenderFns } from "./CmsRegistAffair.vue?vue&type=template&id=cb0e019a&scoped=true&"
import script from "./CmsRegistAffair.vue?vue&type=script&lang=js&"
export * from "./CmsRegistAffair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0e019a",
  null
  
)

export default component.exports